import React from 'react';
export default function Unarchive(_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "1em", height: "1em", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960" },
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M480-581 324-425l40 40 86-86v201h60v-201l86 86 40-40zm-300-93v494h600v-494zm-60 554v-609l82-111h555l83 111v609zm77-614h565l-36-46H233zm283 307" })));
}
